import React, { useState } from 'react';
import moment from 'moment';
import { getTaskStatus } from 'global/utils';
import { Loader } from 'global/styles';
import { Box, Icon, IconButton, Tooltip } from '@mui/material';
import { get, size, startCase } from 'global/lib/lodash';
import { ImageList } from 'global/components/image';
import useStyles from './comment.styles';
import { Text } from '../text';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import sendData from '../../../redux/actions/sendData';
import Confirm from '../confirm';

const Comment = (props) => {
  const { author, body, createdAt, images, meta, isNew, user } = props;
  const [conf, setConf] = useState({});
  const classes = useStyles();
  const isCommentOwner = Number(get(user, 'id')) === Number(get(author, 'id'));
  const isAdminInRealm = props.isAdmin && Number(get(user, 'realm.id')) === get(props, 'authorRealmId');
  const status = getTaskStatus(meta);

  const hasImages = size(images) > 0;

  const isCorrection = get(meta, 'showCorrection');
  const showIcon = get(props, 'showIcon', true);
  const isChange = get(meta, 'valuesChanged');
  const isRelChange = get(meta, 'relationshipsChanged');
  const canDeleteComment = (isCommentOwner || isAdminInRealm) && !isCorrection && !isChange && !isRelChange;

  const formatChangeVal = (obj, k) => {
    const { to, from } = obj[k] || {};

    const ret = {
      to,
      from,
    };

    if (`${k}`.toLowerCase().includes('date')) {
      ret.to = moment(to).format('YYYY-MM-DD');
    }

    if (ret.from == null) {
      ret.from = 'none';
    }

    if (ret.to == null) {
      ret.to = 'none';
    }

    return ret;
  };

  const handleDeleteCommentClicked = async () => {
    try {
      await sendData({
        method: 'DELETE',
        url: `/comments/${props.id}`,
      });
      props.onDeleted?.(props.id);
    } catch (e) {
    } finally {
      setConf({});
    }
  };

  const handleSetConfirmationProps = () => {
    setConf({
      title: 'Delete Comment',
      content: 'Are you sure you want to delete this comment? This action cannot be undone.',
      onOk: handleDeleteCommentClicked,
      onCancel: () => setConf({}),
    });
  };

  return (
    <div className={classes.container}>
      {showIcon && <div className={classes.leftIcon}>{isNew ? <Loader size={16} classes={{ svg: classes.whiteIcon }} /> : <Icon>{status.icon}</Icon>}</div>}
      <Box display="flex" justifyContent="space-between">
        <div className={classes.textContainer}>
          <div className={classes.dateRow}>
            <div className={classes.author}>{get(author, 'name', get(author, 'email', ''))}</div>
            <div className={classes.date}>{moment(createdAt).format('L hh:mma')}</div>
          </div>

          {isCorrection && (
            <div className={classes.correctionContainer}>
              <Text type="secondarySub">Status</Text>
              <span className={classes.bold}>{`Correction: `}</span>
              <span>{`status changed to ${status.title}`}</span>
            </div>
          )}

          <div className={classes.text}>
            <Text type="secondarySub">Comment</Text>
            {body}
          </div>

          {isChange &&
            Object.keys(isChange).map((k) => {
              const { to, from } = formatChangeVal(isChange, k); // isChange[k] || {};
              return (
                <div className={classes.changeContainer}>
                  <Text type="secondarySub">{`${startCase(k)}`}</Text>
                  <span style={{ fontStyle: 'italic' }}>{`${from} → ${to}`}</span>
                </div>
              );
            })}

          {isRelChange &&
            Object.keys(isRelChange).map((k) => {
              const c = isRelChange[k];
              return (
                <div className={classes.changeContainer}>
                  <Text type="secondarySub">{`${startCase(k)}`}</Text>
                  <span style={{ fontStyle: 'italic' }} dangerouslySetInnerHTML={{ __html: `${c.join('<br />')}` }} />
                </div>
              );
            })}

          {hasImages && (
            <div className={classes.imagesContainer}>
              <ImageList images={images} showCaption={true} spaceBetween={2} />
            </div>
          )}
        </div>
        {canDeleteComment && (
          <Box>
            <Tooltip title="Delete Comment">
              <IconButton variant="outlined" color="error" onClick={handleSetConfirmationProps}>
                <DeleteOutlineIcon />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      </Box>
      <Confirm {...conf} />
    </div>
  );
};

export default Comment;
